import React from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'

const SidebarLink = styled(Link)`
display: flex;
color: #FFFFFF;
justify-content: flex-start;
align-items:center;
padding: 20px 15px;
list-style: none;
height: 40px;
text-decoration: none;
font-size: 15px;

&:hover {
    background: #265384;
    border-left: solid 4px #FF7547;
    cursor: pointer;
}
`

const SidebarLabel = styled.span`
margin-left: 16px;
`
const privateMenu = (item, login) => {
    if(login && item.private) {
        return(
            <SidebarLink to={item.path}>
                <div>
                    {item.icon}
                    <SidebarLabel>{item.title}</SidebarLabel>
                </div>
            </SidebarLink>
        )
    } else     if (!login && !item.private) {
        return (<SidebarLink to={item.path}>
                <div>
                    {item.icon}
                    <SidebarLabel>{item.title}</SidebarLabel>
                </div>
            </SidebarLink>
            )
    }

}

const SubMenu = ({item, login}) => {
    return (
    <>
        {privateMenu(item, login)}
    </>
    )
}

export default SubMenu